class RouteSuggestionCollection extends App.Collections.BaseCollection {
    url = '';
    model = App.Models.RouteSuggestion;
}

App.Collections.RouteSuggestion = RouteSuggestionCollection;
